export default __webpack_public_path__ + "5bc2295b86e1fe5801d75ea3ab3a68e2.svg";